import { GHLLanguageKeys as o } from "./ghl-ui.es297.js";
import e from "./ghl-ui.es839.js";
const m = {
  name: o.dutch,
  locale: e
};
export {
  m as date_nl
};
